// Draw a celebration certificate on a canvas and download it as PNG.

function drawTigerFace(ctx, cx, cy, size) {
  const s = size;
  // head
  ctx.fillStyle = "#FF8C00";
  ctx.beginPath();
  ctx.ellipse(cx, cy, s, s * 0.85, 0, 0, Math.PI * 2);
  ctx.fill();
  // ears
  ctx.beginPath();
  ctx.arc(cx - s * 0.7, cy - s * 0.6, s * 0.28, 0, Math.PI * 2);
  ctx.arc(cx + s * 0.7, cy - s * 0.6, s * 0.28, 0, Math.PI * 2);
  ctx.fill();
  ctx.fillStyle = "#FFD9A8";
  ctx.beginPath();
  ctx.arc(cx - s * 0.7, cy - s * 0.6, s * 0.15, 0, Math.PI * 2);
  ctx.arc(cx + s * 0.7, cy - s * 0.6, s * 0.15, 0, Math.PI * 2);
  ctx.fill();
  // muzzle
  ctx.fillStyle = "#FFF6E0";
  ctx.beginPath();
  ctx.ellipse(cx, cy + s * 0.25, s * 0.55, s * 0.4, 0, 0, Math.PI * 2);
  ctx.fill();
  // stripes
  ctx.strokeStyle = "#281E12";
  ctx.lineWidth = s * 0.08;
  ctx.lineCap = "round";
  for (let i = -2; i <= 2; i++) {
    ctx.beginPath();
    ctx.moveTo(cx + i * s * 0.28, cy - s * 0.85);
    ctx.lineTo(cx + i * s * 0.32, cy - s * 0.55);
    ctx.stroke();
  }
  ctx.beginPath();
  ctx.moveTo(cx - s * 0.95, cy - s * 0.05);
  ctx.lineTo(cx - s * 0.7, cy - s * 0.05);
  ctx.moveTo(cx + s * 0.7, cy - s * 0.05);
  ctx.lineTo(cx + s * 0.95, cy - s * 0.05);
  ctx.stroke();
  // eyes
  ctx.fillStyle = "#281E12";
  ctx.beginPath();
  ctx.arc(cx - s * 0.32, cy - s * 0.1, s * 0.09, 0, Math.PI * 2);
  ctx.arc(cx + s * 0.32, cy - s * 0.1, s * 0.09, 0, Math.PI * 2);
  ctx.fill();
  ctx.fillStyle = "#fff";
  ctx.beginPath();
  ctx.arc(cx - s * 0.3, cy - s * 0.13, s * 0.03, 0, Math.PI * 2);
  ctx.arc(cx + s * 0.34, cy - s * 0.13, s * 0.03, 0, Math.PI * 2);
  ctx.fill();
  // nose
  ctx.fillStyle = "#281E12";
  ctx.beginPath();
  ctx.moveTo(cx, cy + s * 0.05);
  ctx.lineTo(cx - s * 0.12, cy + s * 0.18);
  ctx.lineTo(cx + s * 0.12, cy + s * 0.18);
  ctx.closePath();
  ctx.fill();
  // smile
  ctx.strokeStyle = "#281E12";
  ctx.lineWidth = s * 0.05;
  ctx.beginPath();
  ctx.moveTo(cx, cy + s * 0.18);
  ctx.lineTo(cx, cy + s * 0.32);
  ctx.moveTo(cx, cy + s * 0.32);
  ctx.quadraticCurveTo(cx - s * 0.18, cy + s * 0.45, cx - s * 0.3, cy + s * 0.32);
  ctx.moveTo(cx, cy + s * 0.32);
  ctx.quadraticCurveTo(cx + s * 0.18, cy + s * 0.45, cx + s * 0.3, cy + s * 0.32);
  ctx.stroke();
}

function drawStar(ctx, cx, cy, r, filled = true) {
  ctx.beginPath();
  for (let i = 0; i < 10; i++) {
    const angle = (Math.PI * 2 * i) / 10 - Math.PI / 2;
    const radius = i % 2 === 0 ? r : r * 0.45;
    const x = cx + Math.cos(angle) * radius;
    const y = cy + Math.sin(angle) * radius;
    if (i === 0) ctx.moveTo(x, y);
    else ctx.lineTo(x, y);
  }
  ctx.closePath();
  if (filled) {
    ctx.fillStyle = "#FFD166";
    ctx.fill();
  }
  ctx.strokeStyle = "#281E12";
  ctx.lineWidth = 4;
  ctx.stroke();
}

export function buildCertificateCanvas({ name, levelName, stars }) {
  const W = 900;
  const H = 600;
  const canvas = document.createElement("canvas");
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext("2d");

  // Background paper
  ctx.fillStyle = "#FFFDF7";
  ctx.fillRect(0, 0, W, H);

  // Decorative dots
  ctx.fillStyle = "rgba(40,30,18,0.06)";
  for (let x = 0; x < W; x += 22) {
    for (let y = 0; y < H; y += 22) {
      ctx.beginPath();
      ctx.arc(x, y, 1.5, 0, Math.PI * 2);
      ctx.fill();
    }
  }

  // Outer frame
  ctx.strokeStyle = "#281E12";
  ctx.lineWidth = 8;
  ctx.strokeRect(20, 20, W - 40, H - 40);
  ctx.strokeStyle = "#FF8C00";
  ctx.lineWidth = 4;
  ctx.strokeRect(38, 38, W - 76, H - 76);

  // Stripe tape top
  for (let i = 0; i < 14; i++) {
    ctx.fillStyle = i % 2 === 0 ? "#281E12" : "#FF8C00";
    ctx.fillRect(60 + i * 56, 60, 56, 18);
  }

  // Title
  ctx.fillStyle = "#281E12";
  ctx.textAlign = "center";
  ctx.font = "bold 56px Fredoka, sans-serif";
  ctx.fillText("TIGER HERO!", W / 2, 150);

  ctx.font = "600 22px Nunito, sans-serif";
  ctx.fillStyle = "#5C4A3D";
  ctx.fillText("Tigersforkids.com — Official Adventure Certificate", W / 2, 185);

  // Tiger face
  drawTigerFace(ctx, 180, 360, 100);

  // Name + level
  ctx.font = "600 22px Nunito, sans-serif";
  ctx.fillStyle = "#5C4A3D";
  ctx.textAlign = "left";
  ctx.fillText("Awarded to", 320, 250);

  ctx.font = "bold 52px Fredoka, sans-serif";
  ctx.fillStyle = "#FF8C00";
  const safeName = (name || "Tiger Hero").slice(0, 20).toUpperCase();
  ctx.fillText(safeName, 320, 310);

  ctx.font = "600 22px Nunito, sans-serif";
  ctx.fillStyle = "#281E12";
  ctx.fillText(`for completing the level:`, 320, 350);
  ctx.font = "bold 32px Fredoka, sans-serif";
  ctx.fillStyle = "#2D6A4F";
  ctx.fillText(levelName, 320, 392);

  // Stars
  const starY = 470;
  const starGap = 80;
  const startX = W / 2 - starGap;
  for (let i = 0; i < 3; i++) {
    drawStar(ctx, startX + i * starGap, starY, 32, i < stars);
  }

  // Footer
  ctx.font = "600 16px Nunito, sans-serif";
  ctx.fillStyle = "#8A7666";
  ctx.textAlign = "center";
  ctx.fillText(
    "Conceptualised by Romir Mishra · Grade 1 · Heritage International Xperiential School, Gurugram",
    W / 2,
    H - 50,
  );

  return canvas;
}

export function downloadCertificate({ name, levelName, stars }) {
  const canvas = buildCertificateCanvas({ name, levelName, stars });
  canvas.toBlob((blob) => {
    if (!blob) return;
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `tiger-hero-${(name || "kid").toLowerCase().replace(/\s+/g, "-")}-${levelName
      .toLowerCase()
      .replace(/\s+/g, "-")}.png`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 1500);
  }, "image/png");
}
